import { Component, EventEmitter, Inject, Input, OnInit, Output, QueryList } from '@angular/core';
import { ControlContainer, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidatorFormFieldService, ValidatorsPatterns } from './../../shared/services/forms/validator-form-field.service';
import { CatalogService } from './../../shared/services/catalogs/catalog.service';
import { CopyService } from './../../shared/services/copies/copy.service';
import { findInArray, getValueProperty, isAssignedValue, memoize, setValueProperty, promiseAll, fillString, centerDialog, scrollTop } from './../../shared/helpers/functions.helpers';
import { ClientNotFoundException, ClientsService, RiskLevelErrorService } from './../../shared/services/clients/clients.service';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/es-CO'
import { RequestSolicitationsService } from '../../shared/services/solicitations/request-solicitations.service';
import { ApplicationService, EApplication } from '../../shared/services/application/application.service';
import { LinkupService } from '../../shared/services/link-up/linkup.service';
import { BaseComponent } from '../../shared/components/base-component';
import { camelCase } from 'lodash';
import { EVENT } from '../../shared/constants/dali.constants';
import { ClientValidationService, IRequestClientValidation } from '../../shared/services/solicitations/client-validation.service';
registerLocaleData(localeFr, 'es');

export enum EActionDialog {
  CANCEL = 'action1',
  OK = 'action2'
}

export enum EStatusFindClient {
  FOUND = 'found',
  ERROR = 'error',
  NOT_FOUND = 'not_found',
  FOUND_CLIENT_VALIDATION = 'client_validation',
  NO_VALIDATE = 'no_validate'
}

export enum EDocumentTypeId {
  NIT = '3',
  CC = '1',
  CE = '2',
  PA = '5',
  SE = '7',
  TI = '4',
  PD = '17',
  CF = '30'
}

export enum EValidationClientData {
  family_names = 'client_surnames',
  gender = 'gender',
  city = 'city',
  street = 'address',
  sub_segment_id = 'subsegment',
  department = 'state',
  segment_id = 'segment',
  code_ciiu = 'economic_activity',
  given_names = 'client_names',
  company_name = 'company_name'
}

export interface IEventResponseFindClient {
  status: EStatusFindClient,
  documentType: number | string,
  documentNumber: number | string,
  client?: any
}

export interface IClientService {
  find(documentNumber: string | number, documentType: string | number): any;
}
@Component({
  selector: 'app-form-solicitation-basic-data',
  templateUrl: './form-solicitation-basic-data.component.html',
  styleUrls: ['./form-solicitation-basic-data.component.scss']
})
export class FormSolicitationBasicDataComponent extends BaseComponent implements OnInit {

  form: FormGroup = this.fb.group({});

  CONTENT_BOUNDS: any[] | any;

  documentTypeList: any[] = [];
  statesList: any[] = [];
  citiesList: any[] = [];

  segmentList: Array<{ name: string, id: any, subsegments: Array<any> }> = [];

  subsegmentList: Array<{ name: string, id: any, segmentId: any }> = [];

  economicActivityList: Array<{ name: string, id: any }> = [];

  public loadClient = false;

  readonly ID_TYPE_DOCUMENT_NIT = EDocumentTypeId.NIT;
  readonly ID_TYPE_DOCUMENT_CC = EDocumentTypeId.CC;
  readonly ID_TYPE_DOCUMENT_CE = EDocumentTypeId.CE;
  readonly ID_TYPE_DOCUMENT_PA = EDocumentTypeId.PA;
  readonly ID_TYPE_DOCUMENT_SE = EDocumentTypeId.SE;
  readonly ID_TYPE_DOCUMENT_TI = EDocumentTypeId.TI;
  readonly ID_TYPE_DOCUMENT_PD = EDocumentTypeId.PD;

  @Input()
  data: any;

  // Ajustar nueva implementacion
  //@Input()
  //clientService?: IClientService;

  @Output()
  findClient: EventEmitter<IEventResponseFindClient> = new EventEmitter<IEventResponseFindClient>();

  /**
  * Permite mostrar en pantalla el dialogo para consultar un nuevo cliente a phoenix
  */
  showDialogConfirm = false;
  showDialogRiskNvl = false;
  textDialogRiskNvl = "";
  riskconfirm = false;

  isLoading = false;
  /*registerStateAndCity = false;
  registerSegmentAndSubSegment = false;
  registerGender = false;*/

  genderList: QueryList<any> | any = {} as QueryList<any>;
  not_preset_gender: any;
  not_implies_gender: any;
  MASK_PATTERN_ADDRESS: any;
  public _nameLength: any = undefined;
  public get nameLength(): any {
    let asn = async () => await Promise.resolve(this.cps.getCopy("form-solicitation-basic-data")).then((data: any) => { this.nameLength = data?.nameLength; return this.nameLength; });
    return this._nameLength ?? asn();
  }
  public set nameLength(value: any) {
    this._nameLength = value;
  }

  actionToken = 'radication';

  constructor(
    private readonly fb: FormBuilder,
    private readonly cps: CopyService,
    private readonly _catalog: CatalogService,
    private readonly controlContainer: ControlContainer,
    public validatorFormField: ValidatorFormFieldService,
    private readonly clientService: ClientsService,
    private readonly requestSoli: RequestSolicitationsService,
    public readonly app: ApplicationService,
    private link: LinkupService,
    private readonly _clientValidationService: ClientValidationService
  ) {
    super(app, link, 'form-solicitation-basic-data');
  }

  ngOnInit(): void {
    this.initControls().then(() => {
      this.loadStaticValues()
        .finally(() => {
          this.loadData();
        });
    });
  }

  /**
   * Permite inicializar los campos del formulario en el componente
   */
  async initControls() {
    const form = this.controlContainer.control as FormGroup;
    if (form) {
      this.form = form;
    }
    const PATTERN_ADDRESS = await this.validatorFormField.validatorPattern(ValidatorsPatterns.ADDRESS);
    const PATTERN_PLAIN_TEXT = await this.validatorFormField.validatorPattern(ValidatorsPatterns.PLAIN_TEXT);
    const PATTERN_ALPHANUMERIC = await this.validatorFormField.validatorPattern(ValidatorsPatterns.ALPHANUMERIC);
    const NAMELENGTH = await this.nameLength;
    /*this.MASK_PATTERN_ADDRESS = [' ', '-', '#', '/', '.', /[0-9]/, /[a-z]/, /[A-Z]/]
    const patternAddress = new RegExp(PATTERN_ADDRESS);
    for (let index = 0; index < 10; index++) {
      this.MASK_PATTERN_ADDRESS.push(patternAddress);
    }*/
    this.form.addControl("document_type_temp", this.fb.control('', [Validators.required]));
    this.form.addControl("document_number_temp",
      this.fb.control('', [
        Validators.required,
        Validators.pattern(PATTERN_ALPHANUMERIC),
        Validators.minLength(2),
        Validators.maxLength(13)
      ]));
    this.form.addControl("customer_loaded", this.fb.control(false, []));
    this.form.addControl("customer_exists", this.fb.control(false, []));
    this.form.addControl("customer_error", this.fb.control(false, []));
    this.form.addControl("client_id", this.fb.control(null, []));
    this.form.addControl("document_type", this.fb.control('', [Validators.required]));
    this.form.addControl("document_number", this.fb.control('', [Validators.required]));
    this.form.addControl("client_names", this.fb.control('', [Validators.required, Validators.pattern(PATTERN_PLAIN_TEXT), Validators.maxLength(NAMELENGTH)]));
    this.form.addControl("client_surnames", this.fb.control('', [Validators.pattern(PATTERN_PLAIN_TEXT), Validators.maxLength(NAMELENGTH)]));
    this.form.addControl("state", this.fb.control('', [Validators.required]));
    this.form.addControl("city", this.fb.control('', [Validators.required]));
    this.form.addControl("address", this.fb.control('', [Validators.required, Validators.pattern(PATTERN_ADDRESS)]));
    this.form.addControl("economic_activity", this.fb.control('', [/*Validators.required*/]));
    this.form.addControl("segment", this.fb.control('', []));
    this.form.addControl("subsegment", this.fb.control('', []));
    this.form.addControl("gender", this.fb.control('', []));
    this.form.addControl("originator_branch", this.fb.control('', []));
    this.form.addControl("isNaturalPerson", this.fb.control(false, []));
    this.form.addControl("document_type_desc", this.fb.control('', []));

    /**
     * Nueva implementación pruebas 5436
     */
    let existData = {
      client_id: false,
      document_type: false,
      document_number: false,
      client_names: false,
      client_surnames: false,
      state: false,
      city: false,
      address: false,
      economic_activity: false,
      segment: false,
      subsegment: false,
      gender: false,
      originator_branch: false
    };
    this.form.addControl('exist_data', this.fb.control(existData, []));
    this.form.addControl('customer_validation', this.fb.control(false, []));

    this.form.updateValueAndValidity();
    await this.registerDynamicValidators();
  }

  /**
   * Permite controlar las validaciones segun los datos ingresados por el usuario
   */
  async registerDynamicValidators() {

    const PATTERN_PLAIN_TEXT = await this.validatorFormField.validatorPattern(ValidatorsPatterns.PLAIN_TEXT);
    const PATTERN_CEDULA = await this.validatorFormField.validatorPattern(ValidatorsPatterns.CEDULA);
    const PATTERN_NIT = await this.validatorFormField.validatorPattern(ValidatorsPatterns.NIT);
    const PATTERN_EXTRANJERIA = await this.validatorFormField.validatorPattern(ValidatorsPatterns.EXTRANJERIA);
    const PATTERN_PASAPORTE = await this.validatorFormField.validatorPattern(ValidatorsPatterns.PASAPORTE);
    const PATTERN_SOC_EXT_SIN_NIT_COL = await this.validatorFormField.validatorPattern(ValidatorsPatterns.PATTERN_SOC_EXT_SIN_NIT_COL);
    const PATTERN_TI = await this.validatorFormField.validatorPattern(ValidatorsPatterns.TI);
    const PATTERN_PD = await this.validatorFormField.validatorPattern(ValidatorsPatterns.PD);
    const NAMELENGTH = await this.nameLength;

    const documentType = this.form.get('document_type_temp');
    const documentNumber = this.form.get('document_number_temp');
    const clientSurnames = this.form.get('client_surnames');
    const state = this.form.get('state');
    const city = this.form.get('city');
    const segment = this.form.get('segment');
    const subsegment = this.form.get('subsegment');
    const gender = this.form.get('gender');
    const isNaturalPerson = this.form.get('isNaturalPerson');

    if (documentType && documentNumber && clientSurnames && gender && isNaturalPerson) {

      documentType.valueChanges.subscribe(value => {
        isNaturalPerson.patchValue(true);
        documentNumber.clearValidators();
        documentNumber.addValidators([Validators.required]);
        gender.addValidators([Validators.required]);
        gender.reset();
        gender.setErrors(null);
        clientSurnames.clearValidators();
        clientSurnames.addValidators([Validators.required, Validators.pattern(PATTERN_PLAIN_TEXT), Validators.maxLength(NAMELENGTH)]);
        if (value === this.ID_TYPE_DOCUMENT_CC) {
          documentNumber.addValidators([Validators.pattern(PATTERN_CEDULA)]);
        } else if (value === this.ID_TYPE_DOCUMENT_CE) {
          documentNumber.addValidators([Validators.pattern(PATTERN_EXTRANJERIA)]);
        } else if (value === this.ID_TYPE_DOCUMENT_PA) {
          documentNumber.addValidators([Validators.pattern(PATTERN_PASAPORTE)]);
        } else if (value === this.ID_TYPE_DOCUMENT_NIT) {
          clientSurnames.clearValidators();
          documentNumber.addValidators([Validators.pattern(PATTERN_NIT)]);
          clientSurnames.patchValue('');

          gender.clearValidators();
          gender.patchValue(getValueProperty(this.CONTENT_BOUNDS, 'controls.gender.not_implies_gender', 10));
          gender.updateValueAndValidity();
          isNaturalPerson.patchValue(false);
        } else if (value === this.ID_TYPE_DOCUMENT_SE) {
          documentNumber.addValidators([Validators.pattern(PATTERN_SOC_EXT_SIN_NIT_COL)]);
          clientSurnames.clearValidators();
          clientSurnames.patchValue('');
          gender.clearValidators();
          gender.patchValue(getValueProperty(this.CONTENT_BOUNDS, 'controls.gender.not_implies_gender', 10));
          gender.updateValueAndValidity();
          isNaturalPerson.patchValue(false);
        } else if (value === this.ID_TYPE_DOCUMENT_TI) {
          documentNumber.addValidators([Validators.pattern(PATTERN_TI)]);
        } else if (value === this.ID_TYPE_DOCUMENT_PD) {
          documentNumber.addValidators([Validators.pattern(PATTERN_PD)]);
        }

        documentNumber.updateValueAndValidity();
      });
    }

    if (state && city) {
      state.valueChanges.subscribe(async (value) => {
        if (value) {
          this.citiesList = await this._catalog.getCitiesByState(value);
        } else {
          this.citiesList = [];
        }

        // Verificamos si la ciudad existe en el listado, en caso de no existir reiniciamos su valor
        const existCity = this.citiesList.find(cityList => cityList.id == city.value);
        if (!existCity) {
          city.patchValue('');
          city.markAsUntouched();
          city.markAsPristine();
        }

      });
    }
    if (segment && subsegment) {
      segment.valueChanges.subscribe(async (value) => {
        if (value) {
          this.subsegmentList = await this._catalog.getSubsegments(value);
        } else {
          this.subsegmentList = [];
        }

        const existSubSegment = findInArray(this.subsegmentList, 'id', subsegment.value);
        if (!existSubSegment) {
          subsegment.patchValue('');
          subsegment.markAsUntouched();
          subsegment.markAsPristine();
        }
      });
    }
  }

  /**
   * Permite la carga de textos y listas estaticas
   */
  async loadStaticValues() {
    await super.loadStaticValues();
    await this.app.recaptchaToken({ action: this.actionToken });
    this.CONTENT_BOUNDS = await this.cps.getCopy("form-solicitation-basic-data");

    let catalogData: Array<{ promise: Promise<any>, context: any, property: string }> = [];
    catalogData.push({
      promise: this._catalog.genders,
      context: this,
      property: 'genderList'
    });
    catalogData.push({
      promise: this._catalog.states,
      context: this,
      property: 'statesList'
    });
    catalogData.push({
      promise: this._catalog.documentTypes,
      context: this,
      property: 'documentTypeList'
    });
    catalogData.push({
      promise: this._catalog.economicActivities,
      context: this,
      property: 'economicActivityList'
    });

    await promiseAll(catalogData);

    this.not_preset_gender = this.CONTENT_BOUNDS.not_preset_gender;
    this.not_implies_gender = this.CONTENT_BOUNDS.not_implies_gender;
    this.clientService.lenght = await this.nameLength;
  }

  async onChangeEvent() {

    const processChangeEvent = !this.getSetting('findClientEvent', 'requestClientValidation', false) && !this.getSetting('findClientEvent', 'request_phoenix', true);

    if (processChangeEvent) {

      this.isLoading = true;

      const DOCUMENT_TYPE_FIELD = this.form.get('document_type_temp');
      const DOCUMENT_NUMBER_FIELD = this.form.get('document_number_temp');
      const DOCUMENT_TYPE_VALID = getValueProperty(DOCUMENT_TYPE_FIELD, 'valid', true);
      const DOCUMENT_NUMBER_VALID = getValueProperty(DOCUMENT_NUMBER_FIELD, 'valid', true);

      if (!DOCUMENT_TYPE_VALID || !DOCUMENT_NUMBER_VALID) {

        this.form.patchValue({
          customer_exists: false,
          customer_loaded: false,
          customer_error: false
        });

        this.isLoading = false;
        return;
      }

      let word = findInArray(this.documentTypeList, "id", getValueProperty(DOCUMENT_TYPE_FIELD, 'value'));
      let code = findInArray(word.parameters, "key", "code");
      word = camelCase(word.name);
      word = word[0].toUpperCase() + word.substring(1);
      setValueProperty(this.requestSoli, "solicitation.analyticsData.document_type", word);

      const documentType = getValueProperty(DOCUMENT_TYPE_FIELD, 'value');
      const documentNumber = getValueProperty(DOCUMENT_NUMBER_FIELD, 'value');

      let eventResponse: IEventResponseFindClient = {
        status: EStatusFindClient.NO_VALIDATE,
        documentNumber,
        documentType,
        client: undefined
      }

      /**
       * Valores por defecto requerimiento PPG327PP-7234
       */
      const DEFAULT_DATA = this.getSetting("defaultDataForm");
      if (DEFAULT_DATA) {
        for (let control of Object.keys(DEFAULT_DATA)) {
          if (this.form.contains(control)) {
            let field: any = {};
            field[control] = getValueProperty(DEFAULT_DATA, control)
            this.form.patchValue(field);
          }
        }
      }

      if (getValueProperty(DEFAULT_DATA, 'state', false)) {
        this.statesList = await this._catalog.states;
        this.citiesList = await this._catalog.getCitiesByState(getValueProperty(DEFAULT_DATA, 'state'));
      }

      this.form.patchValue({
        customer_exists: false,
        customer_loaded: true,
        customer_error: false,
        document_type: documentType,
        document_number: documentNumber,
        document_type_desc: code.value
      });

      this.form.patchValue({
        isNaturalPerson: this.isNaturalPerson
      });

      this.form.updateValueAndValidity();

      this.isLoading = false;
      this.findClient.emit(eventResponse);

    }

  }

  /**
   * Encargado de consultar los datos del cliente
   */
  async findClientEvent() {
    let eventSetting = this.getSetting("analytics", "trackEvent.e7", "");
    let pageSetting = this.getSetting("analytics", "pageLoad", "");
    let events = [
      {
        "name": "{EVENT.pv2E7setData.pv2E6transactionName.path}",
        "value": EVENT.pv2E7setData.pv2E6transactionName.value
      },
      {
        "name": "{EVENT.pv2E7setData.pv2E7transactionProductCategory.path}",
        "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
      }
    ];
    setValueProperty(eventSetting, "events", events);
    this.onEvent(eventSetting);
    let word = findInArray(this.documentTypeList, "id", getValueProperty(this.form.get('document_type_temp'), 'value'));
    let code = findInArray(word.parameters, "key", "code");
    word = camelCase(word.name);
    word = word[0].toUpperCase() + word.substring(1);
    setValueProperty(this.requestSoli, "solicitation.analyticsData.document_type", word);

    let isValidCaptcha = true;
    const documentType = getValueProperty(this.form.get('document_type_temp'), 'value');
    const documentNumber = getValueProperty(this.form.get('document_number_temp'), 'value');

    if (this.customerLoaded.value && !this.riskconfirm) {
      this.showDialogConfirm = true;
      centerDialog();
    } else {
      isValidCaptcha = await this.app.validateRecaptcha(this.actionToken);
      this.form.reset({
        document_type: documentType,
        document_number: documentNumber,
        document_type_temp: documentType,
        document_number_temp: documentNumber
      });
      this.form.patchValue({
        document_type_desc: code.value
      });
    }

    if (!this.showDialogConfirm && isValidCaptcha) {
      this.isLoading = true;
      let eventResponse: IEventResponseFindClient = {
        status: EStatusFindClient.NOT_FOUND,
        documentNumber,
        documentType,
        client: undefined
      }
      try {
        /*this.citiesList = await this._catalog.cities;
        this.segmentList = await this._catalog.segments;
        this.subsegmentList = await this._catalog.getSubsegments();*/
        let setting = await this.link.settings;

        let catalogData: Array<{ promise: Promise<any>, context: any, property?: string }> = [];

        catalogData.push({
          promise: this._catalog.cities,
          context: this,
          property: 'citiesList'
        });
        catalogData.push({
          promise: this._catalog.segments,
          context: this,
          property: 'segmentList'
        });
        catalogData.push({
          promise: this._catalog.getSubsegments(),
          context: this,
          property: 'subsegmentList'
        });

        await promiseAll(catalogData);

        let default_data = getValueProperty(
          setting,
          `request.OPERADOR_FIND.${this.app.currentApplication}.default_data`,
          {});
        if (getValueProperty(default_data, "basicData.document_type") == documentType && getValueProperty(default_data, "basicData.document_number") == documentNumber) {
          this.form.patchValue({
            client_id: getValueProperty(default_data, "basicData.client_id", ""),
            client_names: getValueProperty(default_data, "basicData.client_names", ""),
            client_surnames: getValueProperty(default_data, "basicData.client_surnames", ""),
            state: getValueProperty(default_data, "basicData.state", ""),
            city: getValueProperty(default_data, "basicData.city", ""),
            address: getValueProperty(default_data, "basicData.address", ""),
            economic_activity: getValueProperty(default_data, "basicData.economic_activity", ""),
            customer_exists: false,
            customer_loaded: true,
            customer_error: false,
            gender: this.clientGender(this.not_implies_gender),
            originator_branch: getValueProperty(default_data, "basicData.originator_branch", ""),
            isNaturalPerson: getValueProperty(default_data, "basicData.isNaturalPerson", false),
          });
          eventResponse.status = EStatusFindClient.FOUND;
        }
        else {
          let exceptionSettings = false;
          if (this.getSetting('findClientEvent', 'requestClientValidation', false)) {
            const requestData: IRequestClientValidation = {
              document_number: documentNumber,
              document_type: documentType,
              solicitation_application: this.app.currentApplication
            };
            const responseValidation = await this._clientValidationService.send(requestData);
            if (responseValidation.hasOwnProperty("data")) {
              const clientExist = getValueProperty(responseValidation, "data.client_exists", true);
              if (!clientExist) {
                this.form.patchValue({
                  customer_exists: false,
                  customer_loaded: true,
                  customer_error: false
                });
                eventResponse.status = EStatusFindClient.NOT_FOUND;
                eventResponse.client = responseValidation;
              } else {

                /**
                * Nueva implementación pruebas 5436
                */
                let responseExistData = getValueProperty(responseValidation, "data", {});
                let existData: any = this.validateExistData(responseExistData);
                this.form.patchValue({
                  customer_exists: true,
                  customer_loaded: true,
                  customer_error: false,
                  isNaturalPerson: this.isNaturalPerson,
                  exist_data: existData,
                  customer_validation: true
                });
                eventResponse.status = EStatusFindClient.FOUND_CLIENT_VALIDATION;
                eventResponse.client = responseValidation;
              }

              /** @todo Migrar a configuracion settings */
              if (documentType == this.ID_TYPE_DOCUMENT_SE && this.app.currentApplication == EApplication.BANK) {
                this.form.patchValue({
                  state: '9999',
                  city: '9999'
                });
              }

            } else {
              exceptionSettings = true;
            }

          } else if (this.getSetting('findClientEvent', 'request_phoenix', true)) {
            const client = await this.clientService.find(documentNumber, documentType);
            eventResponse.client = client;
            const address = client?.addresses?.find((element: any) => element != undefined);
            const city = findInArray(this.citiesList, 'name', getValueProperty(address, 'city'));
            const NAMELENGTH = await this.nameLength;

            this.form.patchValue({
              client_id: getValueProperty(client, 'client_id'),
              client_names: (!this.isNaturalPerson ? client?.client_name.substring(0, NAMELENGTH) : client?.given_names?.filter((name: string) => name.length >= 1).join(' ').substring(0, NAMELENGTH)) || '',
              client_surnames: (!this.isNaturalPerson ? '' : client?.family_names?.filter((name: string) => name.length >= 1).join(' ').substring(0, NAMELENGTH)) || '',
              state: getValueProperty(city, 'stateId', ''),
              city: getValueProperty(city, 'id', ''),
              address: getValueProperty(address, 'street'),
              economic_activity: getValueProperty(client, 'code_ciiu'),
              segment: getValueProperty(client, 'segment_id'),
              subsegment: getValueProperty(client, 'sub_segment_id'),
              customer_exists: true,
              customer_loaded: true,
              customer_error: false,
              gender: this.isNaturalPerson ? this.clientGender(client?.gender) : this.clientGender(this.not_implies_gender),
              originator_branch: getValueProperty(client, 'originator_branch'),
              isNaturalPerson: this.isNaturalPerson,
              customer_validation: false
            });

            /**
             * Nueva implementación pruebas 5436
             */
            let existData = {
              client_id: isAssignedValue(getValueProperty(this.form, 'value.client_id')),
              document_type: isAssignedValue(documentType),
              document_number: isAssignedValue(documentNumber),
              client_names: isAssignedValue(getValueProperty(this.form, 'value.client_names')),
              client_surnames: isAssignedValue(getValueProperty(this.form, 'value.client_surnames')),

              state: isAssignedValue(getValueProperty(this.form, 'value.state'), true, this.statesList, 'id'),
              city: isAssignedValue(getValueProperty(this.form, 'value.city')),
              address: isAssignedValue(getValueProperty(this.form, 'value.address')),
              economic_activity: isAssignedValue(getValueProperty(this.form, 'value.economic_activity'), true, this.economicActivityList, 'id'),
              segment: isAssignedValue(getValueProperty(this.form, 'value.segment'), true, this.segmentList, 'id'),
              subsegment: isAssignedValue(getValueProperty(this.form, 'value.subsegment')),
              gender: isAssignedValue(getValueProperty(this.form, 'value.gender'), true, this.genderList, 'id'),
              originator_branch: isAssignedValue(getValueProperty(this.form, 'value.originator_branch')),
            };

            this.form.patchValue({
              exist_data: existData
            });
            // Documento encontrado en phoenix
            eventResponse.status = EStatusFindClient.FOUND;

          } else {
            exceptionSettings = true;
          }

          if (this.getSetting('findClientEvent', 'request_risk_level', true)) {
            const client_risknvl = await this.clientService.findRiskNvl(documentNumber, documentType);
            this.requestSoli.solicitation.risknvlData = client_risknvl;
            if (client_risknvl["client_status"] == 2 && this.riskconfirm == false) {
              this.showDialogRiskNvl = true;
              centerDialog();
              this.textDialogRiskNvl = "Cliente desactualizado.";
            }
            else if (client_risknvl["client_status"] == 1 && this.riskconfirm == false) {
              this.showDialogRiskNvl = true;
              centerDialog();
              this.textDialogRiskNvl = "Cliente próximo a desactualizarse.";
            }
            else {
              this.riskconfirm = false;
            }
          }
          if (exceptionSettings) {
            throw new ClientNotFoundException();
          }
        }
      } catch (error) {
        if (error instanceof ClientNotFoundException) {
          eventResponse.status = EStatusFindClient.NOT_FOUND;
          this.form.patchValue({
            customer_exists: false,
            customer_loaded: false,
            customer_error: true,
            isNaturalPerson: this.isNaturalPerson
            //gender: getValueProperty(this.CONTENT_BOUNDS, 'controls.gender.not_implies_gender', 10)
          },
            {
              onlySelf: true,
              emitEvent: false
            });
        } else if (error instanceof RiskLevelErrorService) {
          setValueProperty(this.requestSoli, "solicitation.risknvlData.client_status", 3);
          setValueProperty(this.requestSoli, "solicitation.risknvlData.risk_level_code", 4);
        } else {
          setValueProperty(this.requestSoli, "solicitation.risknvlData.client_status", 3);
          setValueProperty(this.requestSoli, "solicitation.risknvlData.risk_level_code", 4);
          setValueProperty(this.requestSoli, "solicitation.risknvlData.annotations_error", "fallo en servicio de Phoenix");
          eventResponse.status = EStatusFindClient.ERROR;
          this.form.patchValue({
            customer_exists: false,
            customer_loaded: false,
            customer_error: true,
            isNaturalPerson: this.isNaturalPerson
            //gender: getValueProperty(this.CONTENT_BOUNDS, 'controls.gender.not_implies_gender', 10)
          },
            {
              onlySelf: true,
              emitEvent: false
            });
        }
      }
      await this.app.recaptchaToken({ action: this.actionToken });
      this.isLoading = false;
      this.findClient.emit(eventResponse);
    } else if (!isValidCaptcha) {
      console.error('Captcha is invalid');
      await this.app.recaptchaToken({ action: this.actionToken });
    }
  }

  /**
   * Permite asignar los valores pasados por parametros al formulario
   */
  async loadData() {
    if (this.data) {
      if (this.data.segment) {
        this.segmentList = await this._catalog.segments;
        this.subsegmentList = await this._catalog.getSubsegments(this.data.segment);
      }
      if (this.data.state) {
        this.statesList = await this._catalog.states;
        this.citiesList = await this._catalog.getCitiesByState(this.data.state);
      }
      this.form.patchValue(this.data);
      if (this.getSetting('findClientEvent', 'requestClientValidation', false)) {
        this.validateExistData(this.data.exist_data)
      }
    }
  }

  /**
   * Permite obtener la referencia al control customer_loaded
   */
  get customerLoaded(): FormControl {
    return this.form.get('customer_loaded') as FormControl;
  }

  /**
   * Permite obtener la referencia al control customer_loaded
   */
  get customerExists(): FormControl {
    return this.form.get('customer_exists') as FormControl;
  }

  /**
   * Permite obtener la referencia al control customer_error
   */
  get customerError(): FormControl {
    return this.form.get('customer_error') as FormControl;
  }

  /**
   * Permite obtener los mensajes de error
   * @param control
   * @returns
   */
  @memoize()
  async getMessageError(control: { label: string, formControlName: string }, errors: any) {
    const { label, formControlName } = control;
    const formControl = this.form.get(formControlName);
    if (formControl) {
      return this.validatorFormField.getMessageError(label, formControl, errors);
    } else {
      return '';
    }
  }

  /**
    * Permite capturar la respuesta del usuario y continuar el proceso segun la acción realizada
    * @param event
    */
  async dialogButtonClicked(event: any) {
    this.showDialogConfirm = false;

    const documentType = getValueProperty(this.form.get('document_type_temp'), 'value');
    const documentNumber = getValueProperty(this.form.get('document_number_temp'), 'value');

    if (event.type === EActionDialog.OK) {

      this.form.reset({
        document_type: documentType,
        document_number: documentNumber,
        document_type_temp: documentType,
        document_number_temp: documentNumber,
        customer_loaded: false,
        customer_exists: false,
        customer_error: false
      }, { onlySelf: true, emitEvent: false });

      Object.keys(this.form.controls).forEach(key => {
        const control = this.form.get(key);
        if (control) {
          control.setErrors(null);
        }
      });

      this.form.markAsUntouched();
      this.form.markAsPristine();
      this.form.updateValueAndValidity();
      await this.findClientEvent();
    } else {
      this.form.patchValue({
        document_type_temp: documentType,
        document_number_temp: documentNumber
      });
    }
  }

  async dialogRiskButtonClicked(event: any) {
    this.showDialogRiskNvl = false;
    if (event.type === EActionDialog.OK) {
      this.riskconfirm = true;
    } else {
      this.riskconfirm = false;
      this.form.reset();
      Object.keys(this.form.controls).forEach(key => {
        const control = this.form.get(key);
        if (control) {
          control.setErrors(null);
        }
      });

      this.form.markAsUntouched();
      this.form.markAsPristine();
      this.form.updateValueAndValidity();
      this.requestSoli.reset();
    }
  }

  clientGender(id: any) {
    const item = findInArray(this.genderList, 'phoenix', id);
    return getValueProperty(item, 'id');

  }

  /**
   * Permite identificar si es una persona natural
   */
  get isNaturalPerson(): boolean {
    let result = true;
    const documentType = getValueProperty(this.form.get('document_type'), 'value');
    if (documentType && documentType == this.ID_TYPE_DOCUMENT_NIT || documentType == this.ID_TYPE_DOCUMENT_SE) {
      result = false;
    }
    return result;
  }

  showInputData(field: string) {
    const existData = getValueProperty(this.form.get('exist_data'), "value", {});
    return !getValueProperty(existData, field, false);
  }

  get customerValidation(): FormControl {
    return this.form.get('customer_validation') as FormControl;
  }

  get showLabelsClientData() {
    if (this.getSetting('findClientEvent', 'requestClientValidation', false)) {
      let existClientData: boolean = true;
      const existData = getValueProperty(this.form.get('exist_data'), "value", {});
      for (let field of Object.keys(existData)) {
        if ((!this.isNaturalPerson && field === EValidationClientData.family_names) ||
          (this.isNaturalPerson && field === EValidationClientData.company_name)) {
          continue;
        }
        existClientData = existClientData && getValueProperty(existData, field, false);
      }
      return !existClientData;
    } else {
      return true
    }
  }

  validateExistData(responseExistData: any) {
    let existData: any = {};
    if (responseExistData) {
      for (let config of Object.keys(responseExistData)) {
        let form_name = getValueProperty(EValidationClientData, config, config);
        existData[form_name] = responseExistData[config];
        if (existData[form_name]) {
          this.clearValidators(this.form, form_name);
        }
      }

      if (!this.isNaturalPerson) {
        existData[EValidationClientData.company_name] = getValueProperty(responseExistData, 'given_names', false) || getValueProperty(responseExistData, 'family_names', false);
        existData[EValidationClientData.family_names] = existData[EValidationClientData.company_name];
        existData[EValidationClientData.given_names] = existData[EValidationClientData.company_name];

        this.clearValidators(this.form, EValidationClientData.family_names);
        this.clearValidators(this.form, EValidationClientData.given_names);

      }

      this.form.markAsUntouched();
      this.form.markAsPristine();
      this.form.updateValueAndValidity();
    }
    return existData;
  }

  clearValidators(form: FormGroup, field: string) {
    const input = form.get(field);
    if (input) {
      input.clearValidators();
      input.setErrors(null);
    }
  }

}
